import { Component } from '@angular/core';
import { NavParams, PopoverController, Platform } from '@ionic/angular';

import { AuthService } from '../../service/auth.service';

@Component({
    selector: 'app-bulkmenu-popover',
    templateUrl: './bulkmenu-popover.page.html',
    styleUrls: ['./bulkmenu-popover.page.scss'],
})
export class BulkmenuPopoverPage
{
    private resize = null;
    private obj: any;

    constructor(
        private popover: PopoverController,
        private navParams: NavParams,
        private platform: Platform,
        private auth: AuthService
    )
    {
    }

    async ngOnInit()
    {
        this.resize = this.platform.resize.subscribe(() => {
            this.popover.dismiss();
        });

        this.obj = this.navParams.data.obj;
    }

    ngOnDestroy()
    {
        if (this.resize == null) return;
        this.resize.unsubscribe();
        this.resize = null;
    }
}
